// firebase.js
import { initializeApp } from 'firebase/app'; // For core app initialization
import { getAuth } from 'firebase/auth'; // For Auth (modular)
import { getFirestore, collection, addDoc } from 'firebase/firestore'; // For Firestore (modular)
import { getAnalytics } from "firebase/analytics"; // For Analytics (modular)

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBD15h9EE8pHpKnDW_DCgIJjdvHXJkKmWc",
  authDomain: "woaomwebdesign-19ef1.firebaseapp.com",
  databaseURL: "https://woaomwebdesign-19ef1-default-rtdb.firebaseio.com", // This is for Realtime Database, Firestore doesn't use it directly
  projectId: "woaomwebdesign-19ef1",
  storageBucket: "woaomwebdesign-19ef1.firebasestorage.app",
  messagingSenderId: "618216884080",
  appId: "1:618216884080:web:177cbd9dae73c9346131b5",
  measurementId: "G-15K7SCEGLM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize individual Firebase services
const db = getFirestore(app); // Get Firestore instance
const auth = getAuth(app);   // Get Auth instance
const analytics = getAnalytics(app); // Get Analytics instance

// Export the initialized services and relevant Firestore functions
export { auth, db, collection, addDoc };